import { useTranslation } from 'react-i18next';

export function EmployeeRole({
  role,
  isMain = false,
}: {
  role: string;
  isMain?: boolean;
}) {
  const { t } = useTranslation('roles');
  return (
    <>
      <span>{t(role)}</span>
      {isMain && <span>({t('Главный')})</span>}
    </>
  );
}
